<template>
  <!-- star toggle for the page you are on. drops out entirely when the route
       is not a nav destination (detail pages, deep links) or when classic is
       the active theme, so it is safe to drop into any page header. -->
  <button
    v-if="destination"
    type="button"
    class="fi-fav-star"
    :class="{ 'fi-fav-star--on': on }"
    :title="on ? 'Remove from Favorites' : 'Add to Favorites'"
    :aria-pressed="on ? 'true' : 'false'"
    :aria-label="(on ? 'Remove ' : 'Add ') + destination.label + (on ? ' from' : ' to') + ' Favorites'"
    @click="toggle"
  >
    <i class="fa" :class="on ? 'fa-star' : 'fa-star-o'" aria-hidden="true"></i>
  </button>
</template>

<script>
import { mapState } from 'vuex'
import { buildNavContext, resolveNav, matchNavDestination } from '@/nav/registry'
import { isFavorite, toggleFavorite, ensureFavoritesLoaded, favState } from '@/nav/nav_favorites'
import horizonNav from '@/nav/horizon_nav_mixin'

export default {
  name: 'fi_fav_star',
  mixins: [horizonNav],
  data() {
    // held in data so the template re-renders when the shared store changes
    return { favState }
  },
  mounted() {
    ensureFavoritesLoaded()
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    destination() {
      // favorites live in the horizon sidebar, so classic has nowhere to put
      // them -- no rail, no section, nothing a star would feed
      if (!this.horizonNavActive || !this.user) return null
      const ctx = buildNavContext(this.user, this.viewAs)
      return matchNavDestination(resolveNav(ctx), this.$route)
    },
    on() {
      // touch favState.keys so vue tracks the dependency through isFavorite
      return !!this.destination && this.favState.keys.length >= 0 && isFavorite(this.destination.to)
    },
  },
  methods: {
    toggle() {
      if (this.destination) toggleFavorite(this.destination.to)
    },
  },
}
</script>

<style scoped>
.fi-fav-star {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: var(--fi-radius-sm);
  background: transparent;
  /* !important: App.vue globals force steelblue on bare anchors/buttons */
  color: var(--fi-text-muted) !important;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.6;
  transition: color var(--fi-motion-quick), opacity var(--fi-motion-quick), background-color var(--fi-motion-quick);
}
.fi-fav-star:hover {
  background: var(--fi-chrome-hover-bg);
  color: var(--fi-chrome-star) !important;
  opacity: 1;
}
.fi-fav-star--on,
.fi-fav-star--on:hover {
  color: var(--fi-chrome-star) !important;
  opacity: 1;
}
.fi-fav-star:focus { outline: none; box-shadow: none; }
.fi-fav-star:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--fi-action-primary-ring);
}
</style>
